<template>
  <div class="ds-control mobile dsf_teas_student_myAskLeave">
    <div class="leave_header">
      <div class="header">
        <van-image
          class="head-img"
          height="60"
          width="60"
          v-if="dataInfor.photo"
          round
          :src="dataInfor.photo | imgFormat"
        />
        <van-image
          class="head-img"
          height="60"
          width="60"
          v-else
          round
          :src="defaultImg | imgFormat"
        />
        <div class="name">{{ dataInfor.name }}</div>
        <div class="job">{{ dataInfor.dept }}</div>
      </div>
      <div class="header-footer">
        <van-dropdown-menu active-color="#3C8DDB">
          <van-dropdown-item v-model="year.value" @change="yearchange" :options="yearactions" />
          <van-dropdown-item v-model="type.value"  @change="typechange" :options="typeactions" />
        </van-dropdown-menu>
        <!-- <div class="footer-content">
          <div class="first" @click="clickYear">
            <div>年度</div>
            <dsf-icon class="icon-icon_more"></dsf-icon>
          </div>
          <div class="second">
            <dsf-icon class="icon-icon-year lefticon"></dsf-icon>
            <div class="secondtitle">{{ year.name }}</div>
          </div>
        </div>
        <div class="footer-content right">
          <div class="first" @click="clickType">
            <div>分类</div>
            <dsf-icon class="icon-icon_more"></dsf-icon>
          </div>
          <div class="second">
            <dsf-icon class="icon-icon-classification lefticon"></dsf-icon>
            <div class="secondtitle">{{ type.name }}</div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="leave_content">
      <teasLeaveProcess v-if="dataInfor.monthData && dataInfor.monthData.length > 0" :processList="dataInfor.monthData"></teasLeaveProcess>
      <img
        class="nodata"
        v-else
        :src="require('_platform/assets/styles/themes/img/nodata2.png')"
        alt=""
      />
    </div>
    <!-- <van-action-sheet
      v-model="showYear"
      :actions="yearactions"
      title="年度"
      close-on-click-action
      @select="onSelectYear"
    />
    <van-action-sheet
      v-model="showType"
      title="分类"
      :actions="typeactions"
      close-on-click-action
      @select="onSelecttype"
    /> -->
  </div>
</template>

<script>
const testData = {
  photo: "",
  name: "张三三",
  dept: "办公室",
  monthData: [
    {
      month: "10月",
      list: [
        {
          leaveDays: "10月28日 - 10月29日",
          leaveType: "病假",
        },
        {
          leaveDays: "10月8日 - 10月18日",
          leaveType: "事假",
        },
      ],
    },
    {
      month: "8月",
      list: [
        {
          leaveDays: "10月28日 - 10月29日",
          leaveType: "病假",
        },
        {
          leaveDays: "10月8日 - 10月18日",
          leaveType: "事假",
        },
        {
          leaveDays: "10月28日 - 10月29日",
          leaveType: "病假",
        },
      ],
    },
  ],
};
import teasLeaveProcess from "./teasLeaveProcess";
export default dsf.component({
  name: "DsfMobileTeasMyAskLeave",
  mixins: [$mixins.control],
  ctrlCaption: "请假",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "personnel/leave/myLeave",
    },
  },
  components: {
    teasLeaveProcess,
  },
  data() {
    return {
      dataInfor: {},
      year: { text: "", value: "" },
      type: { text: "全部", value: "" },
      showType: false,
      showYear: false,
      yearactions: [],
      typeactions: [],
      defaultImg: dsf.config.setting_public_user_default_header,
    };
  },
  created() {
    var date = new Date();
    this.year.text = date.getFullYear(); //获取完整的年份(4位)
    this.year.value = date.getFullYear(); //获取完整的年份(4位)
    this.getYearTypes();
    if (this.isDesign) {
      this.dataInfor = testData;
    } else {
      //获取信息
      this.getAddanceInfor();
    }
  },
  filters: {
    headerImg: function (value) {
      if (value && value.length != 0) {
        var zp = JSON.parse(value);
        var imgObj = zp[0];
        return dsf.url.getWebPath(imgObj.relativePath);
      } else {
        return dsf.config.setting_public_user_default_header;
      }
    },
  },
  methods: {
    // clickYear() {
    //   this.showYear = true;
    // },
    // onSelectYear(item) {
    //   this.year = item;
    //   this.getAddanceInfor();
    // },
    // clickType() {
    //   this.showType = true;
    // },
    // onSelecttype(item) {
    //   this.type = item;
    //   this.getAddanceInfor();
    // },
    yearchange: function() {
       this.getAddanceInfor();
    },
    typechange: function() {
      this.getAddanceInfor();
    },
    // 获取信息
    getAddanceInfor() {
      var loading = dsf.layer.loading();
      this.$http
        .post(this.sourcesUrl, {
          userId: dsf.getCookie("userId"),
          year: this.year.value,
          leaveTypeValue: this.type.value,
        })
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.dataInfor = res.data;
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    getYearTypes() {
      this.$http
        .post("personnel/leave/getConditions")
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.dealYeartype(res.data);
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    dealYeartype(data) {
      for (let index = 0; index < data.leaveType.length; index++) {
        var obj = { text: "", value: "" };
        var element = data.leaveType[index];
        obj.text = element.text;
        obj.value = element.value;
        this.typeactions.push(obj);
      }
      for (let index = 0; index < data.years.length; index++) {
        var obj = { text: "", value: "" };
        var element = data.years[index];
        obj.text = element;
        obj.value = element;
        this.yearactions.push(obj);
      }
    },
  },
});
</script>